import React, { Component } from 'react';

class RedirectComponent extends Component {
  componentDidMount() {
    const { history } = this.props;
    history.replace('/');
  }

  render() {
    return <div></div>;
  }
}

export default RedirectComponent;
